/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Proof_AgentsInputs */

const en_cap_proof_agents = /** @type {(inputs: Cap_Proof_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent team`)
};

const lv_cap_proof_agents = /** @type {(inputs: Cap_Proof_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aģentu komanda`)
};

/**
* | output |
* | --- |
* | "Agent team" |
*
* @param {Cap_Proof_AgentsInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const cap_proof_agents = /** @type {((inputs?: Cap_Proof_AgentsInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Proof_AgentsInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_cap_proof_agents(inputs)
	return en_cap_proof_agents(inputs)
});